export class HTMLUtils
{
	constructor()
	{
		console.log('You should use this class as a singleton!');
	}

	/**
	 * Removes every child of the element
	 * @param element HTMLElement
	 */
	public static clearElement(element: HTMLElement, alsoRemoveFromDom: boolean = false)
	{
		while (element.lastChild)
		{
			element.removeChild(element.lastChild);
		}

		if (alsoRemoveFromDom)
		{
			HTMLUtils.removeElementFromDOM(element);
		}
	}

	/**
	 * Removes element from DOM
	 * @param element HTMLelement
	 */
	public static removeElementFromDOM(element: HTMLElement)
	{
		if (element.parentElement)
		{
			element.parentElement.removeChild(element);
		}
	}

	public static getSize(element: HTMLElement)
	{
		const box = element.getBoundingClientRect();
		
		return box;
	}
}